import { mapState, mapGetters } from "vuex"
import { orderBy } from "lodash"

const string_utilities = {
    methods: {
        dictionary (dictionary_id, order_by, order_direction, other_value) {
            if(!this.profile_id) return []
            const sorted_terms = (terms) => {
                if(!order_by) return terms
                else {
                    let ordered_terms = terms.slice()
                    const regexp = new RegExp("^" + (other_value || "Other") + "$", "i")
                    ordered_terms = orderBy(ordered_terms, [(term) => {
                        if((typeof term[order_by] === "string") && term[order_by].match(regexp)) return "zzzzz" + (other_value || "Other")
                        return term[order_by]
                    }], order_direction || "asc")
                    return ordered_terms
                }
            }

            let terms = this.raw_terms.filter(term => term.dictionary_id === dictionary_id)
            if(terms.length > 0) return sorted_terms(terms)

            this.$store.dispatch("FETCH_RECORD", { entity: "dictionary", id: dictionary_id, query: { relation_ids: ["term"], fields: ["ns::term;fieldset::choices"] } })

            // in case things are SUPER fast!
            terms = this.raw_terms.filter(term => term.dictionary_id === dictionary_id)
            if(terms.length > 0) return sorted_terms(terms)

            return []
        },
        term (term_id, terms, key_field = "id") {
            if(!terms) return null
            return terms.find(term => {
                return term_id === term[key_field]
            })
        },
        term_value_by (identifier, dictionary_id, id_field = "code_constant", label_field = "name") {
            const term = this.raw_terms.find(term => (term.dictionary_id === dictionary_id) && (term[id_field] === identifier))
            return term ? term[label_field] : ""
        },
        term_value (term_id, terms, key_field = "id", label_field = "name") {
            const term = this.term(term_id, terms, key_field)
            return term ? term[label_field] : ""
        },
        number_of_weekdays_in_range (start, end) {
            const days = this.$moment().isoWeekdayCalc(start, end, [1, 2, 3, 4, 5])
            if(days > 1) return days
            return days + 1
        }
        /*  Vue filters:
        date_string (date) { => nibnut.date-from-now
            return moment(date).fromNow()
        },
        formatted_date_string (date, format) { => nibnut.date
            if(!date) return (format !== null) ? "(no date)" : ""
            return moment(date).format(format || "MMMM DD, YYYY")
        },
        formatted_time_string (date, format) { => nibnut.date("HH:mm")
            if(!date) return (format !== null) ? "(no date)" : ""
            return moment(date).format(format || "HH:mm")
        },
        number_string (number, format) { => nibnut.number
            return numeral(number).format(format || "0,0")
        },
        mailto (email) { => nibnut.mailto
            if(!email) return ""
            return "mailto:" + email
        },
        string_concat () { => nibnut.concat([components], " ")
            // (separator, component1, component2, ...)
            let components = []
            for(let loop = 1; loop < arguments.length; loop++) {
                if(arguments[loop]) components.push(arguments[loop])
            }
            return components.join(arguments[0])
        },
        string_truncate (text, length, ellipsis) { => nibnut.smart-truncate
            if(!text || (text.length <= length)) return text
            let end_with = ellipsis || "..."
            return text.substr(0, length - end_with.length) + end_with
        }
        */
    },
    computed: {
        ...mapState(["profile_id"]),
        ...mapGetters(["entity_records"]),
        raw_dictionaries () {
            return this.entity_records("dictionary")
        },
        raw_terms () {
            return this.entity_records("term")
        },
        hash_params () {
            const hashes = location.hash.slice(1).split("&")
            const params = {}
            hashes.map(hash => {
                const [key, val] = hash.split("=")
                params[key] = decodeURIComponent(val)
            })

            return params
        },
        app_version () {
            // eslint-disable-next-line
            if(process.env.VUE_APP_VERSION) return `v.${process.env.VUE_APP_VERSION}`
            return ""
        },
        current_year () {
            return this.$moment().format("YYYY")
        }
    }
}

export default string_utilities
